import {
  GeckoComponentModel,
  GeckoComponentModelType,
  GeckoHorizontalWeld,
  GeckoVerticalWeld,
} from 'types'

/**
 * A function to get all the welds from a component model.  This is needed because
 * not all component models have a welds-array getter
 * @param componentModel
 */
export function getAllWeldsOnComponent(
  componentModel: GeckoComponentModel
): Array<GeckoHorizontalWeld | GeckoVerticalWeld> {
  switch (componentModel.type) {
    // Components with welds
    case GeckoComponentModelType.VerticalTankShell: {
      return [
        ...componentModel.verticalWeldsArray,
        ...componentModel.horizontalWeldsArray,
      ]
    }
    case GeckoComponentModelType.TankFloor: {
      return [
        ...componentModel.verticalWeldsArray,
        ...componentModel.horizontalWeldsArray,
      ]
    }
    case GeckoComponentModelType.TankFlatRoof: {
      return [
        ...componentModel.verticalWeldsArray,
        ...componentModel.horizontalWeldsArray,
      ]
    }
    case GeckoComponentModelType.ShipDeck: {
      return [
        ...componentModel.verticalWeldsArray,
        ...componentModel.horizontalWeldsArray,
      ]
    }
    case GeckoComponentModelType.BasicShipHull: {
      return [
        ...componentModel.verticalWeldsArray,
        ...componentModel.horizontalWeldsArray,
      ]
    }
    // Components without welds
    case GeckoComponentModelType.HorizontalTankShell: {
      return []
    }
    case GeckoComponentModelType.LegacyBoilerWalls: {
      return []
    }
    case GeckoComponentModelType.PipeSection: {
      return []
    }
    case GeckoComponentModelType.LaunchTube: {
      return []
    }
    case GeckoComponentModelType.LegacyCone: {
      return []
    }
    case GeckoComponentModelType.Cone: {
      return []
    }
    case GeckoComponentModelType.Dome: {
      return []
    }
    case GeckoComponentModelType.DomeWall: {
      return []
    }
    case GeckoComponentModelType.FlatCircularFloor: {
      return []
    }
    case GeckoComponentModelType.VerticalTankFoundation: {
      return []
    }
    case GeckoComponentModelType.MachinedForgingSimple: {
      return []
    }
    case GeckoComponentModelType.PressureVesselShell: {
      return []
    }
    case GeckoComponentModelType.HemisphericalHead: {
      return []
    }
    case GeckoComponentModelType.TorisphericalHead: {
      return []
    }
    case GeckoComponentModelType.EllipsoidalHead: {
      return []
    }
  }
}
